import React, {useEffect, useState} from 'react';
import LogoWhite from '../assets/logowhite.png'
import '../App.css';
import {redirectToStore} from './Helpers';

const includeStore = false;

const links = [
  {page:'main', label:'Home'},
  ...(includeStore ? [{href:'https://shop.gridspot.co', label:'Store'}] : []),
  {page:'how', label:'Managed Service'},
  {page:'contact', label:'Contact'},
];

export default function Nav({page, pageChanged}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const go = link => {
    setOpen(false);
    if (link.href) window.location.href = link.href;
    else pageChanged(link.page);
  };

  const items = links.map(link => (
    <button key={link.label} type="button" className={'nav-link' + (link.page === page ? ' is-active' : '')}
            aria-current={link.page === page ? 'page' : undefined} onClick={() => go(link)}>
      {link.label}
    </button>
  ));

  return (
    <header className="nav">
      <div className="container nav-inner">
        <a className="nav-logo" href="https://www.gridspot.co"><img src={LogoWhite} alt="Gridspot home" width="518" height="351"/></a>
        <nav className="nav-links" aria-label="Main">{items}</nav>
        <div className="nav-actions">
          <button type="button" className="btn btn-primary btn-small" onClick={redirectToStore}>Download App</button>
          <button type="button" className="nav-toggle" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open}
                  aria-controls="nav-menu" onClick={() => setOpen(!open)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              {open ? <path d="M6 6l12 12M18 6L6 18"/> : <path d="M4 7h16M4 12h16M4 17h16"/>}
            </svg>
          </button>
        </div>
      </div>
      {open && <nav id="nav-menu" className="nav-menu" aria-label="Mobile">{items}</nav>}
    </header>
  )
}
